// @flow

import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { Heading, Paragraph } from '@rover/kibble/components';
import Button, { ButtonType } from '@rover/react-lib/components/buttons/Button';
import FormGroup from '@rover/react-lib/components/formFields/FormGroup';
import Textarea from '@rover/react-lib/components/formFields/Textarea';
import type { Pet } from '@rover/react-lib/types';
import { VetInfoConstants } from '@rover/shared/js/constants/translation';

type Props = {
  pet: Pet,
  hasMultiplePets: boolean,
  handleVetInfoChange: (veterinaryInformation: string) => void,
  value: string,
  isEditing: boolean,
  toggleEditing: (pet: Pet) => void,
};

const UpdateButton: StyledComponent<{}> = styled(Button)`
  padding: 0;
`;

const PetVetInfo = ({
  pet,
  hasMultiplePets,
  handleVetInfoChange,
  value,
  isEditing,
  toggleEditing,
}: Props): Node => {
  const inputId = `vet-info-${pet.id}`;

  return (
    <FormGroup>
      {hasMultiplePets && (
        <Heading size="200" marginBottom="0x" textColor="primary">
          <label htmlFor={inputId}>{pet.name}</label>
        </Heading>
      )}
      {isEditing ? (
        <Textarea autoExpand onChange={handleVetInfoChange} value={value} id={inputId} />
      ) : (
        <Paragraph size="200" marginBottom="1x">
          {value}
        </Paragraph>
      )}
      {!isEditing && (
        <UpdateButton buttonType={ButtonType.TEXT} onClick={() => toggleEditing(pet)}>
          {VetInfoConstants.updateButton}
        </UpdateButton>
      )}
    </FormGroup>
  );
};

export default PetVetInfo;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/VetInfo/PetVetInfo.jsx